// src/components/Configurator/renderers/OutletRenderer.jsx
import React from "react";
import { SELECTED_ELEMENT_COLOR, defaultObjectSizes, OBJECT_TYPES } from "../configuratorConstants";
import { ReactComponent as SocketX1Svg } from '../../Assets/socketx1.svg';

const OutletRenderer = ({
  element,
  scale,
  isSelected,
  wallThickness,
  placementSideFactor, // Используется для yOffset и теперь для трансформации
  // wallOrientationType, // Больше не используется, если логика SwitchRenderer верна
}) => {
  const outletDefaults = defaultObjectSizes[OBJECT_TYPES.OUTLET];
  const elementVisualWidthM = element.width || outletDefaults.width;
  const elementVisualHeightM = element.height || outletDefaults.height;
  const elementDepthM = element.depth || outletDefaults.depth || 0.01;

  const elementVisualWidthPx = elementVisualWidthM * scale;
  const elementVisualHeightPx = elementVisualHeightM * scale;
  const wallThicknessPx = wallThickness * scale;
  const elementDepthPx = elementDepthM * scale;

  const yOffset = placementSideFactor * ( (wallThicknessPx / 2) + (elementDepthPx / 2) );

  const svgStyle = {
    fill: isSelected ? "rgba(0, 123, 255, 0.2)" : "rgba(229, 231, 235, 0.95)",
    stroke: isSelected ? SELECTED_ELEMENT_COLOR : "rgba(107, 114, 128, 0.8)",
    strokeWidth: isSelected ? 1.2 / (scale / 50) : 0.6 / (scale / 50),
    transition: "fill 0.1s ease-out, stroke 0.1s ease-out",
  };

  let svgSpecificTransform = "";
  if (placementSideFactor === 1) {
    // Для стен, где dPSF = 1 (например, правая, верхняя)
    svgSpecificTransform = "rotate(0)"; // или просто "" для отсутствия трансформации
  } else if (placementSideFactor === -1) {
    // Для стен, где dPSF = -1 (например, левая, нижняя)
    svgSpecificTransform = "scale(1, -1)"; // Отражение по вертикальной оси SVG
  }

  // Применяем уменьшение ширины, как в SwitchRenderer
  const finalSvgWidth = elementVisualWidthPx / 1.9;

  return (
    <g transform={`translate(0, ${yOffset})`}>
      <g transform={svgSpecificTransform}>
        <SocketX1Svg
           x={-elementVisualWidthPx / 2} 
          y={-elementVisualHeightPx / 6}
          width={elementVisualWidthPx / 0.9}
          height={elementVisualHeightPx}
           
          preserveAspectRatio="xMidYMid meet"
          style={svgStyle}
        />
      </g>
    </g>
  );
};

export default React.memo(OutletRenderer);